export enum KnownFeatureFlags {
  CREDITSETUP = 'enable-credit-setup-feature',
  DIGITALCARDACCESS = 'enable-digital-card-access',
  ENABLECARDMANAGEMENTINAPPS = 'enable-card-management-in-apps',
  FREEZETRANSFERS = 'helix-migration-freeze-all-ach-transactions',
  ENABLESOCUREMANUALREVIEW = 'enable-socure-manual-review-enhancement',
  ENABLELENDERALTERNATIVES = 'enable-lender-alternatives',
  ENABLETAXSTATEMENTS = 'enable-tax-statements-in-apps',
  ENABLECHATTOKENINAPPS = 'enable-chat-token-in-apps',
  ENABLESOCCOLLECTIONINAPPS = 'enable-soc-collection-in-apps'
}
